<template>
    <v-navigation-drawer v-if="!isMobile" app right permanent width="300" color="surface" class="chats-panel-drawer">
        <students-chat-panel-body />
    </v-navigation-drawer>

    <div v-else class="chats-panel--mobile">
        <students-chat-panel-body />
    </div>
</template>

<script>
import StudentsChatPanelBody from "@/components/coach/StudentsChatPanelBody";

export default {
    name: "StudentsChatPanel",
    components: { StudentsChatPanelBody },
}
</script>

<style scoped>
.chats-panel-drawer ::v-deep .v-navigation-drawer__border {
    width: 2px !important;
    background-color: var(--v-outline-base) !important;
}

.chats-panel--mobile {
    box-sizing: border-box;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    overflow: hidden;
    margin-top: 24px;
    height: 70vh;
    min-height: 420px;
}
</style>
